// Action Types
import {createAction, handleActions} from "redux-actions";

const SET_ANNOUNCELIST = 'announce/SET_ANNOUNCELIST';
const SET_TOTAL = 'announce/SET_TOTAL';
const SET_SIZE = 'announce/SET_SIZE';
const SET_PAGE = 'announce/SET_PAGE';

const SET_DETAILA = 'announce/SET_DETAILA';

export const setAnnounceList = createAction(SET_ANNOUNCELIST);
export const setTotal = createAction(SET_TOTAL);
export const setSize = createAction(SET_SIZE);
export const setPage = createAction(SET_PAGE);
export const setDetailAnnounce = createAction(SET_DETAILA);



const initalState = {
    detailAnnounce: {
        title: '',
        content: '',
        createdAt: '',
        files: [],
    },
    announceList: [],
    total: 0,
    size: 10,
    page: 1
}

export default handleActions({
    [SET_ANNOUNCELIST]: (state, action) => ({
        ...state,
        announceList: action.payload,
    }),
    [SET_TOTAL]: (state, action) => ({
        ...state,
        total: action.payload
    }),
    [SET_SIZE]: (state, action) => ({
        ...state,
        size: action.payload
    }),
    [SET_PAGE] : (state, action) => ({
        ...state,
        page: action.payload
    }),
    [SET_DETAILA]: (state, action) => ({
        ...state,
        detailAnnounce: {...action.payload}
    })
}, initalState);
